import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import MainContainer from '../common/MainContainer'
import ElementCreateForm from '../ElementCreateForm'
import { ElementForm } from '../../models/element.model'
import { getElement } from '../../services/element.service'
import TitlebarAction from '../common/TitlebarActions'
import { useProject } from '../../context/ProjectContext'
import { useNavigate } from 'react-router-dom'
import { useNotification } from '../../context/NotificationContext'


interface ElementViewProps {
  element_code: string,
  setBlockScreen: (p: any) => void,
}

const ElementView: React.FC<ElementViewProps> = ({
  element_code,
  setBlockScreen,
}) => {
    const { selectedProject } = useProject()
    const { showNotification } = useNotification();
    
    const navigate = useNavigate()
    const [name, setName] = useState<string>('')
    const [elementForm, setElementForm] = useState<ElementForm>({
      code: '',
      name: '',
      element_type: {id: '', label: ''},
      site: {id: '', label: ''},
      description: '',
      created_date: ''
    })

  const initComponent = () => {
    setBlockScreen(true);
    Promise.all([getElement(selectedProject, element_code)]).then(function (results) {
      setElementForm(results[0]);
      setBlockScreen(false);
      setName(results[0].name);
    }).catch((error) => {
      showNotification(error.response.data)
      setBlockScreen(false);
      setTimeout(() => navigate('/elements/listing'), 1500)
    });
    setBlockScreen(false)
  }

  useEffect(initComponent, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setElementForm({
      ...elementForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSelection = (key: string, value: string): void => {
    setElementForm({
      ...elementForm,
      [key]: value
    });
  }

  return (<>
    <TitlebarAction title={`Elemento: ${name}`} />
    <MainContainer>
      <Box sx={{ marginX: '1vw' }}>

        <ElementCreateForm
          elementForm={elementForm}
          element_code={elementForm.code}
          setBlockScreen={setBlockScreen}
          handleSelection={handleSelection}
          handleChange={handleChange}
          action='view'
        />

      </Box>
    </MainContainer>
  </>);
}

export default ElementView